import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';
import { AppSnackService } from '../services/app-snack.service';

export const authGuard: CanActivateFn = () => {
  const oauthService = inject(OauthService);
  const snackService = inject(AppSnackService);
  const router = inject(Router);

  const token = oauthService.getToken();

  if (!token) {
    snackService.openWithContext('Debe iniciar sesión', 'warning');
    return router.createUrlTree(['/login']);
  }

  if (oauthService.isTokenExpired(token)) {
    oauthService.clearAuthData();
    snackService.openWithContext('Debe iniciar sesión', 'warning');
    return router.createUrlTree(['/login']);
  }

  return true;
};
